<template>
  <div
    v-if="
      $route.path !== '/login' &&
      $route.path !== '/register' &&
      $route.path !== '/' &&
      $route.path !== '/verify'
    "
    style="background-color: #86ab5ef3"
  >
    <v-layout wrap justify-end class="hidden-sm-and-down">
      <v-flex xs12 md12 lg8 pr-lg-3 align-self-center text-center>
        <v-layout wrap justify-end text-center style="color: black">
          <v-flex pa-2>
            <router-link class="routerlink" :to="{ name: 'Home' }">
              <span class="menufont1">Home</span></router-link
            >
          </v-flex>
          <v-flex pa-5>
            <div class="text-center">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-row color="#86ab5ef3" v-bind="attrs" v-on="on">
                    <span class="menufont1">Identification</span>
                  </v-row>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in dropdown" :key="index">
                    <v-list-item-title v-if="item.pos == 1">
                      <div class="text-center">
                        <v-menu
                          transition="slide-x-transition"
                          nudge-right="18"
                          offset-x
                          bottom
                          right
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="black"
                              plain
                              v-bind="attrs"
                              v-on="on"
                              class="text-none"
                            >
                              <span style="font-family: poppins-regular">{{
                                item.title
                              }}</span>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="(item, index) in sub"
                              :key="index"
                            >
                              <v-list-item-title>
                                <div class="text-center">
                                  <router-link
                                    class="routerlink"
                                    :to="(name = item.path + '/' + item.type)"
                                  >
                                    <v-btn
                                      class="text-none"
                                      plain
                                      :ripple="false"
                                    >
                                      <span
                                        style="
                                          font-family: poppins-regular;
                                          color: black;
                                        "
                                        >{{ item.subtitle }}</span
                                      ></v-btn
                                    ></router-link
                                  >
                                </div>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </v-list-item-title>
                    <v-list-item-title v-else>
                      <div class="text-left">
                        <router-link
                          class="routerlink"
                          :to="(name = item.path + '/' + item.type)"
                          ><v-btn class="text-none" plain :ripple="true">
                            <span
                              style="font-family: poppins-regular; color: black"
                              >{{ item.title }}</span
                            ></v-btn
                          ></router-link
                        >
                      </div>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>

            <!-- <v-btn plain elevation="0" color="#86ab5ef3">
              <span>
                <v-select
                class="drops text-none"
                  background-color="#86ab5ef3"
                  v-model="identification"
                  :items="dropdown"
                  label="Identification"
                  color="red"
                  item-text="title"
                  item-value="title"
                  persistent-hint
                  return-object
                  single-line
                >
                </v-select>
              </span>
            </v-btn> -->
          </v-flex>
          <v-flex pl-5 pt-5>
            <!-- <router-link class="routerlink" :to="{ name: 'observationreport' }">
            <span
              class="menufont1"
              >Submit</span
            ></router-link > -->
            <!-- <v-select style="width:75px; height:5px:"
            label="submit"
          solo
          @input="search"
            height="10"
           :items="value"
           v-model="ans"
           small-chips>
           
            </v-select> -->

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-row
                  elevation="0"
                  color="#86AB5EF3"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <span class="menufont1">Submit</span>
                </v-row>
              </template>
              <v-list>
                <v-list-item>
                  <v-btn class="text-none" plain :ripple="false">
                    <router-link
                      class="routerlink"
                      style="color: black"
                      :to="{ name: 'rescuereport' }"
                    >
                      Rescue Report</router-link
                    ></v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn class="text-none" plain :ripple="false">
                    <router-link
                      class="routerlink"
                      style="color: black"
                      :to="{ name: 'observationreport' }"
                    >
                      Observational Report</router-link
                    ></v-btn
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex pa-2>
            <router-link class="routerlink" :to="{ name: 'map' }">
              <span class="menufont1">Assistance facilities</span></router-link
            >
          </v-flex>
          <v-flex pa-2>
            <router-link class="routerlink" :to="{ name: 'resources' }">
              <span class="menufont1">Resources</span></router-link
            >
          </v-flex>
          <v-flex pa-2>
            <router-link class="routerlink" :to="{ name: 'Home' }">
              <span class="menufont1">News</span></router-link
            >
          </v-flex>
          <v-flex pa-2>
            <router-link class="routerlink" :to="{ name: 'profile' }">
              <span class="menufont1">My KURMA</span></router-link
            >
          </v-flex>
          <!-- <v-flex>
          <router-link class="routerlink" :to="{ name: 'about' }">
            <span
              class="menufont2"
              >Help</span
            ></router-link
          >
        </v-flex> -->
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tr: false,
      identification: "",
      dropdown: [
        {
          title: "Freshwater Turtles",
          pos: 1,
        },
        // {
        //   title: "Sea Turtles",
        //   path: "/seaturtles",
        //   type: "Sea Turtles",
        // },
        // {
        //   title: " Invasive Species",
        //   path: "/seaturtles",
        //   type: "Invasive Species",
        // },
        {
          title: "ID Key",
          path: "/glossary",
          type: "ID Key",
        },
      ],

      sub: [
        {
          subtitle: "Softshell",
          path: "/seaturtles",
          type: "Soft-Shell Turtle",
        },
        {
          subtitle: "Hardshell",
          path: "/seaturtles",
          type: "Hard-Shell Turtle",
        },
        {
          subtitle: "Tortoise",
          path: "/seaturtles",
          type: "Tortoise",
        },
      ],
    };
  },
};
</script>
<style>
.routerlink {
  text-decoration: none;
}
</style>